export default "__VITE_ASSET__a50b48aa__"